import { Box } from '@material-ui/core';
import { ReactElement } from 'react';
import { Control, Path } from 'react-hook-form';

import { Body1, TextInputField } from '../../atoms';
import { getPreviewImage } from '../../../utils';

import './image-input-field.styles.scss';
import { useTranslation } from 'react-i18next';

export interface IImageInputFieldProps<T> {
	imageUrl?: string;
	control: Control<T>;
	name: Path<T>;
	label?: string;
	placeholder?: string;
	required?: boolean | undefined;
	fullWidth?: boolean | undefined;
	valid?: boolean | undefined;
	hideLabel?: boolean;
}

export function ImageInputField<T>(
	props: IImageInputFieldProps<T>
): ReactElement {
	const {
		imageUrl,
		control,
		name,
		label,
		placeholder,
		required,
		fullWidth,
		valid,
		hideLabel
	} = props;
	const { t } = useTranslation('map');

	return (
		<Box className="image-input-field">
			<TextInputField
				name={name}
				control={control}
				placeholder={placeholder}
				label={hideLabel ? undefined : label}
				required={required}
				fullWidth={fullWidth}
				valid={valid}
			/>
			{imageUrl && imageUrl.length > 0 && (
				<img src={getPreviewImage(imageUrl)} alt={label} />
			)}
			<Body1 className="image-help">
				{t('attachments.image.imageInternet')}
			</Body1>
		</Box>
	);
}
